export const BuilderActionsEnum = {
    ChangeColors: 'colors',
    ChangePopupColor: 'popup_colors',
    ChangeBorderRadius: 'border_radius',
    ForgotPassword: 'forgot_password',
    FontChange: 'font',
    Login: 'login',
    ForgotUserName: 'forgot_username',
    Registration: 'registration',
    ClosePopup: 'close_popup',
    ChangeLanguage: 'language',
    ChangeLogo: 'logo',
    ChangeLogoUrl: 'logoUrl',
    ChangeSmallLogoUrl: 'smallLogoUrl',
    RecoverPassword: 'recover_password',
    MoveMenuItem: 'menu',
    ClearLocalStorage: 'clear_local_storage',
    ChangeBanner: 'change_banner',
    ChangeIconSet: 'change_icon_set',
    ChangePromotion: 'change_promotion',
    ChangePromotionCategory: 'change_promotion_category',
    ArchivePromotions: 'archive_promotion',
    ChangeBackground: 'background_change',
    UpdateSettings: 'update_settings',
    UpdateAnnouncement: 'update_announcement',
    UpdatePopup: 'update_popup',
    StoryBlock: 'story_block',
    ChangeColorMode: 'change_color_mode',
    ChangeDefaultColorMode: 'change_default_color_mode',
    Reload: 'reload',
    ChangeMyProfile:'my_profile',
    MobileApps: 'update_mobile_apps',
    ImageSet: 'update_image_set',
}

Object.freeze(BuilderActionsEnum);

export default BuilderActionsEnum;